import { Component, Input, OnInit } from '@angular/core';
import { tarjetasFiltrosVideos } from '../data';

@Component({
  selector: 'app-avisos-importantes',
  templateUrl: './avisos-importantes.component.html',
  styleUrls: ['./avisos-importantes.component.scss']
})
export class AvisosImportantesComponent implements OnInit {
  @Input() videoElegido: any;
  listaImagenes:any[]=[
    {
      id:1,
      titulo:'imagen1',
      imagen:'aviso1.jpeg'
    },
    {
      id:2,
      titulo:'imagen2',
      imagen:'aviso2.jpeg'
    },
    {
      id:3,
      titulo:'imagen3',
      imagen:'aviso3.jpeg'
    },
    {
      id:4,
      titulo:'imagen4',
      imagen:'aviso_carga_notas_nivel_sec.jpg'
    },
     {
      id:5,
      titulo:'imagen5',
      imagen:'aviso_carga_eventos.jpg'
    }

  ]

  constructor() {}

  ngOnInit(): void {

  }


}


